<script lang="ts">
	import { page } from '$app/stores';
	import { t } from 'svelte-intl-precompile';
	import { createRadioGroup, melt } from '@melt-ui/svelte';
	import IconExternal from '$lib/assets/svg/icons/arrow-top-right.svg?component';
	import ColoredCircle from '$lib/components/atoms/ColoredCircle/ColoredCircle.svelte';
	import { getActiveMenuItem, getMenuLink, type MenuItem } from '$lib/utils/menu';
	import { isFilterMenuOpened } from '$store/filterMenuStore';

	interface Props {
		menu?: MenuItem[];
		onChange?: (str: string) => void | boolean;
	}

	let { menu = [] as MenuItem[], onChange }: Props = $props();

	const defaultItem = getActiveMenuItem($page.url, menu);

	const {
		elements: { root, item }
	} = createRadioGroup({
		onValueChange: ({ curr, next }) => {
			if (!onChange?.(next)) {
				return curr;
			}

			return next;
		},
		defaultValue: defaultItem
	});

	let active = $derived(getActiveMenuItem($page.url, menu));
</script>

{#if !$isFilterMenuOpened}
	<div use:melt={$root} class="SecondLevelMenu">
		{#each menu as menuItem (menuItem)}
			{@const isActive = active === menuItem.name}
			{@const link = getMenuLink(menuItem, $page?.data?.lang)}
			<div
				use:melt={$item(menuItem.name)}
				class="SecondLevelMenu__item"
				data-testid={menuItem.name}
			>
				{#if isActive}
					<ColoredCircle size={8} color="#D82034"></ColoredCircle>
				{/if}
				<a
					href={link}
					class="SecondLevelMenu__link"
					class:SecondLevelMenu__link--active={isActive}
					target={menuItem.onClick?.type === 'external' ? '_blank' : null}
				>
					<span>{$t(`menu.${menuItem.name}`)}</span>
				</a>
				{#if menuItem.onClick?.type === 'external'}
					<span class="SecondLevelMenu__icon"><IconExternal></IconExternal></span>
				{/if}
			</div>
		{/each}
	</div>
{/if}

<style lang="scss" src="./SecondLevelMenu.scss"></style>
